/**
 * ScenarioTabs - Tabs horizontales para escenarios
 *
 * Scroll horizontal en movil, tabs normales en desktop.
 * Incluye boton para anadir nuevo escenario.
 */

import { Plus } from 'lucide-react';
import { useChecklistStore } from '@/store';
import type { Checklist } from '@/core/types';
import { cn } from '@/core/utils';

interface ScenarioTabsProps {
  checklists: Checklist[];
  activeId: string | null;
}

export function ScenarioTabs({ checklists, activeId }: ScenarioTabsProps) {
  const setActiveChecklist = useChecklistStore(
    (state) => state.setActiveChecklist
  );
  const addChecklist = useChecklistStore((state) => state.addChecklist);

  const handleAddNew = () => {
    const name = window.prompt('Nombre del nuevo escenario:');
    if (!name?.trim()) return;

    const emoji = window.prompt('Emoji (opcional):', '📋') || '📋';

    const id = addChecklist({
      name: name.trim(),
      emoji,
      items: [],
      order: checklists.length,
    });

    setActiveChecklist(id);
  };

  return (
    <div className="flex gap-2 overflow-x-auto pb-2 -mx-4 px-4 scrollbar-hide">
      {checklists.map((checklist) => (
        <button
          key={checklist.id}
          onClick={() => setActiveChecklist(checklist.id)}
          className={cn(
            'flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors',
            'flex-shrink-0',
            activeId === checklist.id
              ? 'bg-slate-800 text-slate-100'
              : 'bg-slate-900 text-slate-400 hover:text-slate-200 hover:bg-slate-800/50'
          )}
        >
          <span>{checklist.emoji}</span>
          <span>{checklist.name}</span>
        </button>
      ))}

      {/* Add New Scenario Button */}
      <button
        onClick={handleAddNew}
        className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors flex-shrink-0 bg-slate-900 text-slate-500 hover:text-slate-300 hover:bg-slate-800/50 border border-dashed border-slate-700"
      >
        <Plus className="w-4 h-4" />
        <span className="hidden sm:inline">Nuevo</span>
      </button>
    </div>
  );
}
